module.exports = __webpack_public_path__ + "static/media/poster1.7f02514a.jpg";